import React, { useState, useEffect, useContext } from "react";
import LandingNav from "../../Landing_Nav";
import LandingFooter from "../../Landing_Footer";
import { useNavigate } from "react-router-dom";
import group9 from "../../../../images/LandingPageImage/whatsapp_campaign.webp";
import google from "../../../../images/LandingPageImage/google.png";
import CtaSection from "../CtaSection";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import MyContext from "../../../../MyContext";
import { useLocation } from "react-router-dom";

const WhatsappCampaign = () => {
  const slideData = {
    id: 1,
    title: "WhatsApp Campaign: Boost Your Engagement with Automated Messaging",
    subtitle:
      "The WhatsApp Campaign feature allows you to reach your customers directly with automated messages. It makes sharing offers, updates, and announcements easy, helping your business stay connected and boost engagement.",
    image: group9,
    ctaPrimary: "Start Free Trial",
    ctaSecondary: "Start Free Trial",
  };

  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
   const location = useLocation();
  const { openFreeTrialModal } = useContext(MyContext);
  const [openIndex, setOpenIndex] = useState(null);

  const arrowStyle = { width: "20px", height: "20px", flexShrink: 0 };
  const faqs = [
    {
      question: "Why should I use WhatsApp for marketing",
      answer:
        "  WhatsApp allows direct and instant communication with customers, making your messages more likely to be seen and acted upon.",
    },

    {
      question: " Can WhatsApp campaigns be personalized?",
      answer:
        "Yes, you can send tailored messages, offers, and recommendations to individual customers for better engagement.",
    },

    {
      question: "How often can I send WhatsApp campaigns?",
      answer:
        " You can send campaigns as often as needed, but it’s best to avoid spamming and focus on relevant content.",
    },

    {
      question: " Will WhatsApp campaigns increase sales?",
      answer:
        " Yes, targeted and timely messages can boost customer engagement, encourage repeat purchases, and drive higher sales.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    // small stagger so animations appear after mount
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

   useEffect(() => {
      const pageKey = location.pathname;
      const storageKey = `freeTrialClosed_${pageKey}`;
    
      if (!sessionStorage.getItem(storageKey)) {
        openFreeTrialModal(pageKey);
      }
    
      return () => {
        sessionStorage.removeItem(storageKey);
      };
    }, [location.pathname]);

  const slide = slideData;
  
  return (
    <>
      <LandingNav />

      {/* first section */}

      <style>{`
        :root {
          --hero-bg-1: #1E1B4B;
          --hero-bg-2: #2F2CD8;
          --accent: #4B63FF;
          --accent-light: #e4e6f7ff;
          --max-width: 1600px;

          /* THESE MUST MATCH LandingNav .ln-container paddings */
          --nav-padding-desktop: 5rem;   /* desktop padding in LandingNav */
          --nav-padding-xl: 4rem;        /* <=1400px */
          --nav-padding-lg: 3rem;        /* <=1200px */
          --nav-padding-md: 2rem;        /* <=992px */
          --nav-padding-sm: 1.25rem;     /* <=768px */
        }

        .hero-section {
          width: 100%;
          background: linear-gradient(135deg, var(--hero-bg-1), var(--hero-bg-2));
          padding: 4rem 0;
          position: relative;
          overflow: hidden;
          min-height: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* hero-container uses same left padding as navbar so text aligns under logo */
        .hero-container {
          width: 100%;
          max-width: var(--max-width);
          margin: 0 auto;
          display: flex;
          padding-left: var(--nav-padding-desktop);
          padding-right: var(--nav-padding-desktop);
          align-items: center;
          justify-content: space-between;
          gap: 2rem;
        }

        /* left column */
        .hero-left {
          flex: 1 1 48%;
          max-width: 720px;
          z-index: 3;
          text-align: left;
        }

        .hero-title {
          font-size: 2.4rem;
          font-weight: 700;
          line-height: 1.12;
          color: #ffffff;
          margin: 0;
          opacity: 0;
          transform: translateX(-110%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1), transform 900ms cubic-bezier(.2,.9,.2,1);
        }

        .hero-title.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .pink-text {
          color: var(--accent);
        }

        .hero-sub {
          margin-top: 1rem;
          font-size: 1.05rem;
          color: #ffffff;
          line-height: 1.5;
          max-width: 60ch;
          opacity: 0;
          transform: translateX(-110%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 150ms, transform 900ms cubic-bezier(.2,.9,.2,1) 150ms;
        }

        .hero-sub.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .hero-ctas {
          margin-top: 1.5rem;
          display: flex;
          gap: 0.9rem;
          flex-wrap: wrap;
          opacity: 0;
          transform: translateX(-110%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 250ms, transform 900ms cubic-bezier(.2,.9,.2,1) 250ms;
        }

        .hero-ctas.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .btn-primary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 28px;
          padding: 0.6rem 1.2rem;
          font-weight: 700;
          cursor: pointer;
          border: none;
          outline: none;
          white-space: nowrap;
          background: var(--accent);
          color: #fff;
          transition: background 200ms ease, color 200ms ease, transform 150ms ease;
        }

        .btn-primary:hover,
        .btn-primary:focus {
          background: var(--accent-light);
          color: var(--accent);
          transform: translateY(-2px);
        }

         .btn-secondary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 28px;
          padding: 0.6rem 1.2rem;
          font-weight: 700;
          cursor: pointer;
          border: none;
          outline: none;
          white-space: nowrap;
          background: var(--accent);
          color: #fff;
          transition: background 200ms ease, color 200ms ease, transform 150ms ease;
        }

        .btn-secondary:hover,
        .btn-secondary:focus {
          background: var(--accent-light);
          color: var(--accent);
          transform: translateY(-2px);
        }

        /* right column - image */
        .hero-right {
          flex: 1 1 48%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 1;
          max-width: 720px;
          height: 520px;
          padding-right: calc(var(--nav-padding-desktop) * 0.6); /* slight offset to match visual balance with nav */
        }

        .hero-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          opacity: 0;
          transform: translateX(80%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 120ms, transform 900ms cubic-bezier(.2,.9,.2,1) 120ms;
          pointer-events: none;
          user-select: none;
          max-width: 100%;
          max-height: 100%;
        }

        .hero-image.visible {
          opacity: 1;
          transform: translateX(0);
        }

        /* Small aesthetic vignette/overlay to make text pop */
        .hero-overlay {
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: radial-gradient(800px 400px at 10% 30%, rgba(255,255,255,0.03), transparent 10%),
                      radial-gradient(600px 300px at 90% 70%, rgba(0,0,0,0.18), transparent 15%);
          z-index: 2;
        }

        /* Responsive paddings that match LandingNav breakpoints */
        @media (max-width: 1400px) {
          .hero-container {
            padding-left: var(--nav-padding-xl);
            padding-right: var(--nav-padding-xl);
          }
        }

        @media (max-width: 1200px) {
          .hero-container {
            padding-left: var(--nav-padding-lg);
            padding-right: var(--nav-padding-lg);
          }
        }

        @media (max-width: 992px) {
          .hero-container {
            padding-left: var(--nav-padding-md);
            padding-right: var(--nav-padding-md);
            flex-direction: column;
            align-items: center;
            text-align: center;
          }

          .hero-left {
            max-width: 90%;
            margin: 0 auto;
          }

          .hero-title {
            text-align: center;
          }

          .hero-sub {
            text-align: center;
            max-width: 38ch;
            margin-left: auto;
            margin-right: auto;
          }

          .hero-ctas {
            justify-content: center;
            margin-bottom: 1.5rem;
          }

          .hero-right {
            height: 360px;
            padding-right: 0;
            margin-top: 0.5rem;
          }
        }

        @media (max-width: 768px) {
          .hero-container {
            padding-left: var(--nav-padding-sm);
            padding-right: var(--nav-padding-sm);
          }
          .hero-title { font-size: 1.6rem; }
          .hero-sub { font-size: 1rem; }
          .hero-right { height: 300px; }
        }

        @media (max-width: 480px) {
          .hero-container {
            padding-left: 1.2rem;
            padding-right: 1.2rem;
          }
          .hero-left { max-width: 95%; }
          .hero-right { height: 240px; }
        }
      `}</style>

      <section
        className="hero-section"
        aria-label="WhatsAppBulkSend hero section"
      >
        <div className="hero-container">
          {/* LEFT: Text */}
          <div className="hero-left">
            <h1 className={`hero-title ${isVisible ? "visible" : ""}`}>
              {slide.title}
            </h1>

            <p className={`hero-sub ${isVisible ? "visible" : ""}`}>
              {slide.subtitle}
            </p>

            <div className={`hero-ctas ${isVisible ? "visible" : ""}`}>
              <button
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={() => navigate("/login?provider=google")}
              >
                <span>Continue with</span>
                <img
                  src={google}
                  alt="Google"
                  style={{ width: "28px", height: "28px" }}
                />
              </button>

              <button onClick={openFreeTrialModal} className="btn-secondary">
                {slide.ctaPrimary}
              </button>
            </div>
          </div>

          {/* RIGHT: Image */}
          <div className="hero-right" aria-hidden="true">
            <img
              src={slide.image}
              alt="Illustration: WhatsApp automation workspace"
              className={`hero-image ${isVisible ? "visible" : ""}`}
              loading="lazy"
              draggable={false}
            />
            <div className="hero-overlay" aria-hidden="true" />
          </div>
        </div>
      </section>

      {/* second section */}

      <style>{`
        .content-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 60px 20px;
        }

       .content-title {
            font-size: 32px;
            font-weight: 700;
            margin: 0 auto 24px;   
            display: flex;
            align-items: center;
            justify-content: center;
            max-width: 600px;
            text-align: center;
            color: #2F2CD8;
            }

        .card-row1 {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
          margin-top: 40px;
        }

        .info-card {
          border-radius: 12px;
          padding: 24px;
          background: #4B63FF;
        }

        .info-card h3 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 12px;
          text-align: left;
          color: #ffffff;
        }

        .info-card p {
          font-size: 15px;
          line-height: 1.6;
          color: #ffffff;
          text-align: left;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .content-title {
            font-size: 26px;
          }

          .card-row1 {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="content-container">
        <h2 className="content-title">
          How Does a WhatsApp Campaign Help Businesses Grow?
        </h2>

        <p className="content-para">
          A WhatsApp campaign helps businesses grow by enabling direct and
          instant communication with customers on a platform they use daily.
        </p>

        {/* Cards */}
        <div className="card-row1">
          <div className="info-card">
            <h3>Engage Customers Instantly</h3>
            <p>
              Reach your customers directly on WhatsApp with timely messages,
              ensuring they see your offers, updates, and announcements
              immediately.
            </p>
          </div>

          <div className="info-card">
            <h3>Drive More Sales</h3>
            <p>
              Personalized and targeted messaging encourages purchases, boosts
              repeat orders, and helps turn customer interactions into revenue.
            </p>
          </div>
        </div>
      </div>

      {/* third section */}

      <style>{`
        .content-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 60px 20px;
        }

       .content-title {
            font-size: 32px;
            font-weight: 700;
            margin: 0 auto 24px;   
            display: flex;
            align-items: center;
            justify-content: center;
            max-width: 600px;
            text-align: center;
            color: #2F2CD8;
            }

            .content-para {
            max-width: 900px;
            margin: 0 auto 15px;
            line-height: 1.5;
            color: #444;
            font-size: 16px;
            text-align: center;
            }

        .card-row {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
          margin-top: 40px;
        }

        .info-card {
        //   border: 1px solid #e5e5e5;
          border-radius: 12px;
          padding: 24px;
          background: #4B63FF;
        }

        .info-card h3 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 12px;
          text-align: left;
          color: #ffffff;
        }

        .info-card p {
          font-size: 15px;
          line-height: 1.6;
          color: #ffffff;
          text-align: left;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .content-title {
            font-size: 26px;
          }

          .card-row {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="content-container">
        <h2 className="content-title">
          Why WhatsApp Campaigns Are a Game-Changer for E-Commerce
        </h2>

        <p className="content-para">
          WhatsApp campaigns are a game-changer for e-commerce because they
          allow businesses to connect with customers directly and personally.
        </p>

        {/* Cards */}
        <div className="card-row">
          <div className="info-card">
            <h3>Direct Customer Connection</h3>
            <p>
              Communicate with customers instantly on a platform they use every
              day.
            </p>
          </div>

          <div className="info-card">
            <h3>Boost Engagement Easily</h3>
            <p>
              Share updates, offers, and messages that capture attention and
              encourage interaction.
            </p>
          </div>

          <div className="info-card">
            <h3>Increase Sales Effectively</h3>
            <p>
              Turn personalized messaging into higher conversions and repeat
              purchases.
            </p>
          </div>
        </div>
      </div>

      {/* forth section */}

      <style>{`
        .content-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 60px 20px;
        }

       .content-title {
            font-size: 32px;
            font-weight: 700;
            margin: 0 auto 24px;   
            display: flex;
            align-items: center;
            justify-content: center;
            max-width: 600px;
            text-align: center;
            color: #2F2CD8;
            }

            .content-para {
            max-width: 900px;
            margin: 0 auto 15px;
            line-height: 1.5;
            color: #444;
            font-size: 16px;
            text-align: center;
            }

        .card-row {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
          margin-top: 40px;
        }

        .info-card {
        //   border: 1px solid #e5e5e5;
          border-radius: 12px;
          padding: 24px;
          background: #2F2CD8;
        }

        .info-card h3 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 12px;
          text-align: left;
          color: #ffffff;
        }

        .info-card p {
          font-size: 15px;
          line-height: 1.6;
          color: #ffffff;
          text-align: left;
        }

        /* Responsive */

        @media (max-width: 992px) {
            .card-row {
                grid-template-columns: repeat(2, 1fr); /* 2 cards per row */
            }
            }

        @media (max-width: 768px) {
          .content-title {
            font-size: 26px;
          }

          .card-row {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="content-container">
        <h2 className="content-title">
          Grow Your Business Faster with WhatsApp Campaigns
        </h2>

        <p className="content-para">
          WhatsApp campaigns help businesses grow faster by enabling direct,
          instant, and personalized communication with customers. They make it
          easy to share offers, updates, and promotions, increasing engagement,
          building trust, and driving more sales efficiently
        </p>

        {/* Cards */}
        <div className="card-row">
          <div className="info-card">
            <h3>Instant Customer Alerts</h3>
            <p>
              Send messages to customers right away so they never miss updates.
            </p>
          </div>

          <div className="info-card">
            <h3>Tailored Promotions</h3>
            <p>
             Share offers and deals that match each customer’s interests.
            </p>
          </div>

          <div className="info-card">
            <h3>Easy Campaign Management</h3>
            <p>Create, schedule, and manage messages effortlessly in one place.</p>
          </div>

          <div className="info-card">
            <h3>Higher Open Rates </h3>
            <p> Ensure more customers see and read your messages.</p>
          </div>

          <div className="info-card">
            <h3>Build Customer Loyalty</h3>
            <p> Strengthen trust and keep customers coming back.</p>
          </div>

          <div className="info-card">
            <h3>Increase Revenue</h3>
            <p> Turn engagement into more sales and business growth.</p>
          </div>
        </div>
      </div>

      {/* fifth section */}

      <div
        className="container-fluid d-flex flex-column"
        style={{ background: "#ffffff" }}
      >
        <div className="row mt-4 mb-5">
          <div className="col-lg-3 d-none d-lg-block"></div>
          <div className="col-12 col-lg-6 px-3 px-md-4">
            <h2 className="text-center text-black mt-5 mb-4 fs-4">
              Frequently Asked Questions
            </h2>

            <div className="row ">
              <div className="col-12 p-3">
                {faqs.map((faq, index) => {
                  const isOpen = openIndex === index;

                  return (
                    <div
                      key={index}
                      onClick={() => toggleFAQ(index)}
                      style={{
                        background: isOpen ? "#EFEFEF" : "#D9D9D9",
                        borderRadius: "12px",
                        padding: "20px 18px",
                        marginBottom: "14px",
                        cursor: "pointer",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <p
                          className="mb-0"
                          style={{
                            fontSize: "18px",
                            minWidth: "200px",
                            color: isOpen ? "#000000" : "#000000",
                            fontWeight: isOpen ? "600" : "400",
                          }}
                        >
                          {faq.question}
                        </p>

                        {isOpen ? (
                          <FiChevronUp style={arrowStyle} color="#000000" />
                        ) : (
                          <FiChevronDown style={arrowStyle} color="#000000e0" />
                        )}
                      </div>

                      {isOpen && (
                        <p
                          style={{
                            fontSize: "15px",
                            color: "#6F7D98",
                            marginTop: "10px",
                            lineHeight: "1.5",
                            maxWidth: "85%",
                          }}
                        >
                          {faq.answer}
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-lg-3 d-none d-lg-block"></div>
        </div>
      </div>

      <CtaSection />
      <LandingFooter />
    </>
  );
};

export default WhatsappCampaign;
